import React, { useState, useEffect } from 'react';
import { certificatesAPI, getImageUrl } from '../utils/api';

const Certifications = () => {
    const [certificates, setCertificates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchCertificates();
    }, []);

    const fetchCertificates = async () => {
        try {
            setLoading(true);
            const response = await certificatesAPI.getAll();
            setCertificates(response.data);
            setError(null);
        } catch (err) {
            console.error('Error fetching certificates:', err);
            setError('Failed to load certificates');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container mx-auto px-4 py-8 min-h-screen">
            <h1 className="text-3xl font-bold text-gray-800 mb-8 text-center" data-aos="fade-down">Our Certifications</h1>

            {/* Certificates Grid */}
            {loading ? (
                <div className="flex justify-center items-center py-20">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
                </div>
            ) : error ? (
                <div className="text-center text-red-500 py-10">
                    <p>{error}</p>
                    <button
                        onClick={fetchCertificates}
                        className="mt-4 text-blue-600 hover:underline"
                    >
                        Try Again
                    </button>
                </div>
            ) : certificates.length === 0 ? (
                <div className="text-center text-gray-500 py-10">
                    <i className="fas fa-certificate text-4xl mb-3 text-gray-300"></i>
                    <p>No certifications available yet.</p>
                </div>
            ) : (
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                    {certificates.map((cert) => (
                        <div key={cert._id} className="bg-white rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 overflow-hidden border border-gray-100 group" data-aos="fade-up">
                            <div className="relative h-64 bg-gray-50 flex items-center justify-center p-4">
                                <img
                                    src={getImageUrl(cert.image)}
                                    alt={cert.title}
                                    className="max-w-full max-h-full object-contain transform group-hover:scale-105 transition-transform duration-500"
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = 'https://placehold.co/400x600?text=No+Image';
                                    }}
                                />
                            </div>
                            <div className="p-4 text-center bg-white">
                                <h3 className="font-semibold text-gray-800 text-lg">{cert.title}</h3>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default Certifications;
